"use client";

import { Link, useLocation } from "react-router-dom";

const YEAR = new Date().getFullYear();
const NAV_SECTIONS = {
  company: [
    { name: "About Us", to: "/about" },
    { name: "Our Network", to: "/services" },
    { name: "Partners", to: "/partners" },
    { name: "Contact", to: "/contact" },
  ],
  services: [
    { name: "Voice Connectivity", to: "/services" },
    { name: "Messaging Solutions", to: "/services" },
    { name: "Global Interconnects", to: "/services" },
    { name: "Network Analytics", to: "/services" },
  ],
};

// Click helper: if link points to the SAME path, scroll to top instead of re-navigating
function FooterLink({ to, className, children }) {
  const { pathname } = useLocation();
  const onClick = (e) => {
    if (to === pathname) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  return (
    <Link to={to} onClick={onClick} className={className}>
      {children}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer
      role="contentinfo"
      aria-labelledby="footer-heading"
      className="bg-gray-900 text-white">
      <div className="container-custom py-12">
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand / Intro */}
          <div className="md:col-span-2">
            <FooterLink
              to="/"
              className="text-2xl font-bold text-primary-400 hover:text-primary-300 transition-colors inline-block mb-4">
              Faef Global
            </FooterLink>
            <p className="text-gray-300 max-w-md">
              Your trusted global telecommunications partner, connecting
              businesses worldwide with reliable, scalable communication
              solutions.
            </p>
            <p className="text-sm text-gray-400 mt-4">
              “Our Route to Your Destination”
            </p>
          </div>

          {/* Company */}
          <nav aria-label="Company" className="space-y-3">
            <h3 className="font-semibold">Company</h3>
            <ul className="space-y-2">
              {NAV_SECTIONS.company.map(({ name, to }) => (
                <li key={name}>
                  <FooterLink
                    to={to}
                    className="text-gray-300 hover:text-primary-400 transition-colors text-sm">
                    {name}
                  </FooterLink>
                </li>
              ))}
            </ul>
          </nav>

          {/* Services */}
          <nav aria-label="Services" className="space-y-3">
            <h3 className="font-semibold">Services</h3>
            <ul className="space-y-2">
              {NAV_SECTIONS.services.map(({ name, to }) => (
                <li key={name}>
                  <FooterLink
                    to={to}
                    className="text-gray-300 hover:text-primary-400 transition-colors text-sm">
                    {name}
                  </FooterLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            © {YEAR} Faef Global. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a
              href="/privacy"
              className="text-gray-400 hover:text-primary-400 transition-colors text-sm">
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="text-gray-400 hover:text-primary-400 transition-colors text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
